// Deep-linking to a profile tab via a URL hash (e.g. `/action-center/user/417#giving`)
// is a legacy entry point. The profile tab system is driven by the `profileTab`
// query param, and react-router must see that param on its FIRST render — otherwise
// UserMenu finds no `profileTab` and defaults the URL to the user's last-used tab
// (newsfeed), clobbering the intended tab. The legacy handler can only set the param
// via history.replaceState, which react-router never observes.
//
// So, before the app (and react-router) boots, rewrite `#<tab>` into
// `?profileTab=<tab>` on profile pages. The existing param-driven flow then takes over
// and an invalid tab is corrected by useRedirectToValidTab.
//
// See: UserMenu.jsx (default-tab effect), userProfileHandler.js (param branch),
// Utilities/Hooks/useUrlParams.js (reads via react-router useLocation).

// The user profile shows when the path matches `*/user/:userID` (see Routes.js).
const USER_PROFILE_PATH = /\/user\/[^/?#]+/;

export default function redirectProfileHashToParam() {
  const { hash, pathname, search } = window.location;

  // Nothing to convert, or not a profile page that treats the hash as a tab.
  if (hash.length <= 1 || !USER_PROFILE_PATH.test(pathname)) return;

  const params = new URLSearchParams(search);

  // An explicit profileTab param wins over the hash; just drop the stale hash.
  if (!params.has("profileTab")) params.set("profileTab", hash.slice(1));

  window.history.replaceState(
    null,
    document.title,
    `${pathname}?${params.toString()}`
  );
}
